import React, { useEffect, useRef } from "react";
import styles from "./index.module.scss";
import classNames from "classnames";

type FixDrawerProps = {
  open: boolean;
  onClose?: () => void;
  label?: string;
  children: React.ReactNode;
  placement?: "top" | "bottom" | "start" | "end";
  isOutsideCloseButtonVisible?: boolean;
  customVariant?: "default" | "wide";
};

export const FixDrawer: React.FC<FixDrawerProps> = ({ open, onClose, label, children, placement = "end", isOutsideCloseButtonVisible = true, customVariant = "default" }) => {
  const drawerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape" && open && onClose) {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [open, onClose]);

  const handleBackdropClick = (e: React.MouseEvent) => {
    onClose?.();
  };

  const hostStyles = [styles["fix-drawer-backdrop"], styles[customVariant]];
  const drawerPanelStyles = [styles["fix-drawer-panel"], styles[placement]];

  if (open) {
    hostStyles.push(styles["open"]);
    drawerPanelStyles.push(styles["open"]);
  }

  return (
    <div ref={drawerRef} className={classNames(hostStyles)}>
      <div className={classNames(drawerPanelStyles)}>
        {label && <header className={styles["fix-drawer-header"]}>{label}</header>}
        <div className={styles["fix-drawer-body"]}>{children}</div>
      </div>
      <div className={styles["side"]} onClick={handleBackdropClick}>
        {isOutsideCloseButtonVisible && (
          <button className={styles["fix-drawer-close"]} onClick={onClose} aria-label="Close drawer">
            ×
          </button>
        )}
      </div>
    </div>
  );
};
